module.exports = __webpack_public_path__ + "img/devicebox.72299399.png";